import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from '@environments/environment';
import {Result} from "@domain/common/http/result";
import {first} from "rxjs/operators";
import {ConfigurationSoap} from "@domain/admin/parametre/api/soap/configuration-soap";

/**
 * Service de gestion des comptes API Soap
 */
@Injectable()
export class ApiSoapService {
	/**
	 * Constructeur
	 *
	 * @param http Service HTTP
	 */
	constructor(private http: HttpClient) {}

    /**
     * Récupération d'une configuration SOAP
     */
    consultParam(): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/ImportWS/consultParam`,null).pipe(first());
    }

    /**
     * Sauvegarde d'une configuration SOAP
     *
     * @param configurationSoap configuration à sauvegarder
     */
    saveParam(configurationSoap: ConfigurationSoap): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/ImportWS/saveParam`,configurationSoap).pipe(first());
    }
}